import { redirect } from '@tanstack/react-router'

import { authStore } from '@/features/auth/services/auth-store'
import { Pages } from '@/shared/config/pages'
import type { Permission } from './permissions'
import { sanitizeReturnTo } from './return-to'

export function guardAuth(
  _required?: ReadonlyArray<Permission>,
  location?: { href?: string },
): void {
  if (!authStore.isAuthenticated()) {
    const returnTo = sanitizeReturnTo(location?.href)
    if (returnTo && returnTo !== Pages.LOGIN) {
      throw redirect({ to: Pages.LOGIN, search: { returnTo } })
    }
    throw redirect({ to: Pages.LOGIN })
  }
}

export function guardAlreadyLoggedIn(returnTo?: unknown): void {
  if (authStore.isAuthenticated()) {
    const target = sanitizeReturnTo(returnTo)
    if (target) {
      throw redirect({ href: target })
    }
    throw redirect({ to: Pages.DASHBOARD })
  }
}
